/**
 * Contexto para abrir a tela de carteiras com um endereço (e opcionalmente dados) pré-preenchidos.
 * Usado pelo modal "Pagamento recebido" para oferecer "Adicionar pagador à lista de carteiras".
 * A função é fornecida pelo MainLayout, que controla addressToAdd/walletDataToAdd e a exibição da WalletList.
 */

import React, { createContext, useContext } from 'react';

const OpenWalletListContext = createContext(null);

/**
 * @param {string} [address] - Endereço a pré-preencher no formulário de cadastro
 * @param {{ address?: string, name?: string, [key: string]: unknown }} [walletData] - Dados opcionais (ex.: do destinatário no envio)
 */
export function OpenWalletListProvider({ children, openWalletListWithAddress }) {
  return (
    <OpenWalletListContext.Provider value={{ openWalletListWithAddress }}>
      {children}
    </OpenWalletListContext.Provider>
  );
}

export function useOpenWalletList() {
  const ctx = useContext(OpenWalletListContext);
  return ctx ?? { openWalletListWithAddress: null };
}
